<template>
  <div class="panel panel-bordered">
    <h2>{{ title }}</h2>
    <!--    <div class="custom-label" >{{$static('mte.t1', 'Завантажте свої зображення сюди')}}</div>-->
    <div class="custom-label" style="color:#565656; margin-top: 25px; font-style: italic">{{ $static('mte.t222',
      'Рекомендований розмір 1080 x 1080 px. Крім того, радимо оптимізувати зображення') }}</div>
    <div class="files-uploader default-files-uploader" style="margin-bottom:20px;">
      <div class="files-uploader-holder" v-if="!settings.images || settings.images.length === 0"
        @click="openFileManager">
        <span class="icon icon-cloud-upload"></span>
        <p>{{ $static('mte.t1', 'Завантажте свої зображення сюди') }}</p>
        <span>{{ $static('mte.t2', 'Зображення повинні мати розширення .png або .jpg') }}</span>
      </div>
      <div class="uploader-previews" @click="openFileManager" v-else>
        <div class="image bg" v-for="(image, index) in settings.images"
          :style="{ backgroundImage: $filters.backgroundImage(image.url) }">
          <a href="#" class="btn-icon btn-remove btn-small" @click.prevent.stop="delImage(index)">
            <span class="icon icon-trash-filled"></span>
          </a>
          <a href="javascript:void(0)" class="btn-icon  btn-small" @click.prevent.stop="moveImage(index, -1)"
            style="bottom: inherit;top: 3px;left: 3px;">
            <span class="icon icon-left"></span>
          </a>
          <a href="javascript:void(0)" class="btn-icon  btn-small" @click.prevent.stop="moveImage(index, 1)"
            style="bottom: inherit;top: 3px;right: 3px;">
            <span class="icon icon-right"></span>
          </a>
        </div>

      </div>
      <div class="image image-placeholder" v-if="settings.images && settings.images.length" @click="openFileManager">
        <div class="text">1080 x 1080</div>
      </div>
    </div>
    <!-- <div class="custom-editor-holder">
            <editor v-model="html"></editor>
    </div>-->

    <textarea rows="10" class="form-control custom-input html-block" v-model="html"></textarea>
    <!-- !Ряды кнопок -->
    <div class="mailing-panel" v-for="(btnRow, btnRowIndex) in buttons" :key="btnRowIndex"
      @removeRow="delButtonRow(btnRowIndex)">
      <template v-for="(btn, btnIndex) in btnRow" :key="btnIndex">
        <MessageButton
          v-if="errors['button'] && errors['button'][btnRowIndex] && errors['button'][btnRowIndex][btnIndex]"
          :item="btn" :errors="errors['button'][btnRowIndex][btnIndex]" @remove="delButton(btnRowIndex, btnIndex)"
          @update:itemType="(payload) => changeBtnType(payload, btnIndex, btnRowIndex)"
          @resetBtnError="(type) => { handleBtnErrorReset(type, btnRowIndex, btnIndex) }" />
      </template>
      <div class="btns mt-2 d-flex">
        <button class=" default-btn btn-with-icon btn-white btn-green" @click="addButton(btnRowIndex)"
          style="margin-right: 15px">
          <span class="text">{{ $static('multisend-i.add-btn', 'Додати кнопку') }}</span>
          <span class="icon icon-add"></span>
        </button>
        <button class=" default-btn btn-with-icon btn-white btn-remove" @click="delButtonRow(btnRowIndex)">
          <span class="text">{{ $static('multisend-i.del-btn-row', 'Видалити ряд кнопок') }}</span>
          <span class="icon icon-trash"></span>
        </button>
      </div>
    </div>
    <button class=" default-btn btn-with-icon btn-white btn-green mt-2" @click="addButtonRow">
      <span class="text">{{ $static('multisend-i.add-btn-row', 'Додати ряд кнопок') }}</span>
      <span class="icon icon-add"></span>
    </button>

    <div class="button-panel">
      <button class="default-btn btn-accent" @click="saveTemplate()">
        <span class="text">{{ $static('mte.t3', 'Зберегти зміни') }}</span>
      </button>
    </div>
    <div class="col-2"></div>
  </div>
</template>

<script>
import api from '@/api'
import MessageButton from '@/views/MessageButton';
import Editor from './Editor';

export default {
  name: 'MessageTemplateEditor',
  components: { MessageButton, Editor },
  props: ['title', 'name'],
  data() {
    return {
      errors: { button: [] },
      html: '',
      settings: {
        images: [],
        button: []
      },
      result: {}
    }
  },

  async mounted() {
    await this.fetchTemplate(this.name);
    // Инициализируем массив `errors['button']` с той же структурой, что и `this.post.template.settings.button`
    if (!this.settings.button) {
      this.settings.button = []
      console.log("sdsd")
    }

    this.errors['button'] = this.buttons.map(subArray =>
      subArray.map(button => ({}))
    );
  },
  computed: {

    buttons() {

      return this.settings.button &&
        Array.isArray(this.settings.button) ? this.settings.button : []
    },
  },
  methods: {
    addButtonRow() {
      console.log("row")
      if (this.buttons?.length) {
        console.log("if")
        this.errors["button"].push([{ textError: false, linkError: false, linkFormatError: false }])
        this.buttons.push([{ type: 'webApp', text: '', link: '' }])
      } else {
        console.log("roelsew")
        this.errors["button"] = [];
        this.errors["button"].push([{ textError: false, linkError: false, linkFormatError: false }])
        this.settings.button = [];
        console.log("this.buttons", this.buttons)
        this.buttons.push([{ type: 'webApp', text: '', link: '' }]);
      }
    },
    addButton(rowIndex) {
      if (this?.buttons[rowIndex]?.length) {
        this.errors["button"][rowIndex].push({ textError: false, linkError: false, linkFormatError: false })
        this.buttons[rowIndex].push({ type: 'webApp', text: '', link: '' })
      } else {
        this.errors["button"][rowIndex] = [];
        this.errors["button"][rowIndex].push({ textError: false, linkError: false, linkFormatError: false })
        this.buttons[rowIndex] = [];
        this.buttons[rowIndex].push({ type: 'webApp', text: '', link: '' });
      }
    },
    delButtonRow(index) {
      this.buttons.splice(index, 1);
    },
    delButton(rowIndex, rowBtnIndex) {
      this.buttons[rowIndex].splice(rowBtnIndex, 1);
    },
    handleBtnErrorReset(type, btnRowIndex, btnIndex) {
      switch (type) {
        case "text": {
          this.errors['button'][btnRowIndex][btnIndex].textError = false;
          break;
        }
        case "link": {
          this.errors['button'][btnRowIndex][btnIndex].linkError = false;
          this.errors['button'][btnRowIndex][btnIndex].linkFormatError = false;
          break;
        }
      }
    },

    checkButtonErrors() {
      this.noButtonErrors = true;
      // Инициализируем массив `errors['button']` с той же структурой, что и `this.post.template.settings.button`
      this.errors['button'] = this.buttons.map(subArray =>
        subArray.map(button => ({}))
      );
      // Проходим по каждому подмассиву и объекту внутри `this.post.template.settings.button`
      this.buttons.forEach((subArray, subIndex) => {
        subArray.forEach((button, buttonIndex) => {
          // Проверяем поле `text`
          if (!button.text || button.text.length === 0) {
            this.errors['button'][subIndex][buttonIndex].textError = true;
            this.noButtonErrors = false;
          }

          // Проверяем поле `link`
          if (!button.link || button.link.length === 0) {
            this.errors['button'][subIndex][buttonIndex].linkError = true;
            this.noButtonErrors = false;
          }

          // Проверяем поле `link` на валидность ссылки
          if (button.link && button.link.length > 0) {
            const urlPattern = new RegExp(
              '^(https?:\\/\\/)' + // Протокол (http или https) — обязателен
              '(([a-zA-Z\\d-]+\\.)+[a-zA-Z]{2,}|' + // Доменное имя должно включать хотя бы одну точку и домен верхнего уровня
              'localhost|' + // Локальный хост
              '((\\d{1,3}\\.){3}\\d{1,3}))' + // Или IP-адрес (v4)
              '(\\:\\d+)?' + // Необязательный порт
              '(\\/[-a-zA-Z\\d%@_.~+&:]*)*' + // Путь
              '(\\?[;&a-zA-Z\\d%@_.,~+&:=-]*)?' + // Параметры
              '(\\#[-a-zA-Z\\d_]*)?$', // Хэш (якорь)
              'i'
            );

            // Проверка ссылки регулярным выражением
            if (!urlPattern.test(button.link)) {
              this.errors['button'][subIndex][buttonIndex].linkFormatError = true;
              this.noButtonErrors = false;
            }
          }
        });
      });
      return this.noButtonErrors;
    },

    changeBtnType(payload, btnIndex, rowIndex) {
      if (payload) {
        this.buttons[rowIndex][btnIndex].type = "webApp"
      }
      else {
        this.buttons[rowIndex][btnIndex].type = "web"
      }
    },

    delImage(index) {
      this.settings.images.splice(index, 1)
    },
    moveImage(index, target) {
      let n = index + target;
      if (n > -1 && n < this.settings.images.length) {
        [this.settings.images[index], this.settings.images[n]] = [this.settings.images[n], this.settings.images[index]]
      }
    },
    openFileManager() {
      window.$('#file-manager').modal('show');
      this.$store.commit('onFileSelect', this.select)
    },
    // openSizeFileManager() {
    //   window.$('#file-manager').modal('show');
    //   this.$store.commit('onFileSelect', this.selectSizeTable)
    // },
    select() {
      // const base = this.$store.getters['fm/settings/baseUrl'];
      this.settings.images = this.$store.getters['fm/selectedItems'].map(i => encodeURI('/storage/' + i.path)).map(i => { return { url: i } });
      this.settings.images = this.settings.images.slice(0, 1);
    },

    validate() {
      // Проверяем кнопки в каждом ряду
      return this.checkButtonErrors();
    },

    async saveTemplate() {
      let valid = this.validate();
      if (!valid) {
        return
      }

      let obj = {
        ...this.result,
        template: this.html,
        settings: this.settings,
        name: this.name
      };

      try {
        const response = await api.post('/api/template', obj);
        const data = response.data;

        this.html = data.template;
        this.settings = data.settings;
        this.result = data;

        this.$notify({
          title: this.$static('start-message.title', 'Стартове повідомлення'),
          text: this.$static('notify.save', 'Збережено.'),
          duration: 2000
        });
      } catch (error) {
        console.error("Error saving template:", error);
        this.$notify({
          title: this.$static('notify.error-title', 'Помилка'),
          text: this.$static('notify.error', 'Помилка при збереженні данних'),
          type: 'error',
          duration: 3000
        });
      }
    },

    async fetchTemplate() {
      try {
        const response = await api.get(`/api/template/${this.name}`);
        const data = response.data;

        if (data.error) {
          return;
        }

        this.html = data.template;
        if (data.settings) {
          this.settings = data.settings;
        }
        this.result = data;
      } catch (error) {
        console.error("Error fetching template:", error);
      }
    }
  }
}
</script>

<style scoped></style>